<template>
  <div class="available-tasks">
    <h2 class="available-tasks_heading">{{ $c('Доступные задания:') }}</h2>
    <div class="available-tasks_content">
      <Tabs
        v-if="availableTasksFilters.length > 1"
        :options="availableTasksFilters"
        @change="onAvailableTasksSelect"
        class="available-tasks_tabs"
      />
      <p class="available-tasks_tab-message" v-if="this.selectedTasksFilter">{{this.selectedTasksFilter.message}}</p>
      <div class="available-tasks_list">
        <Transition
          name="page-transition"
          mode="out-in"
          appear
        >
          <div
            class="available-tasks_list-transition"
            v-bind:key="this.selectedTasksFilter.value"
            ref="taskFilterTransition"
          >
            <Task
              v-bind:key="Math.random()+index"
              v-for="(task, index) in filteredTasks"
              v-bind="{index, ...task}"
            />
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import Tabs from '@/common/components/Tabs'
import Task from '@/components/RandomRewards/TaskList/Task'

const randomRewards = namespace('randomRewards')

@Component({
  components: {
    Tabs,
    Task
  }
})
class AvailableTasks extends Vue {
  @randomRewards.State('tasksFilter') availableTasksFilters
  @randomRewards.State('tasks') availableTasks
  @randomRewards.State('startTask') startTask
  @randomRewards.State('isParticipant') isParticipant
  @randomRewards.State('selectedTasksFilter') selectedTasksFilter

  @randomRewards.Action('setTaskFilter') setTaskFilter

  get filteredTasks () {
    return this.availableTasks.filter(({ filterValue }) => {
      return filterValue === this.selectedTasksFilter.value
    })
  }

  onTaskFilterTransition () {
    this.$refs['taskFilterTransition'].style.maxHeight = this.$refs['taskFilterTransition'].offsetHeight + 'px'
  }

  onAvailableTasksSelect (selected, value) {
    this.setTaskFilter(value)
  }
}

export default AvailableTasks
</script>

<style lang="scss" scoped>
  .available-tasks {
    max-width: 100%;
    @include media_desktop {
      max-width: 510px;
    }
    &_heading {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      color: #ffffff;
      margin-bottom: 24px;
      @include media_desktop {
        font-size: 25px;
        line-height: 30px;
        margin-bottom: 30px;
      }
    }
    &_content {
      width: 100%;
      overflow: hidden;
    }
    &_tab-message {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #666666;
      margin-top: 16px;
      @include media_desktop {
        font-size: 16px;
        line-height: 21px;
      }
      &:before {
        content: '* ';
        color: #ff002a;
      }
    }
    &_list-transition {
      margin-top: 30px;
      position: relative;
      overflow: hidden;
    }
    &_tabs {
      width: 100%;
    }
  }
</style>
